<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="8">
        <div>
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'Landing' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to home</span>
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12">
                <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
              </v-col>
            </v-row>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="loading.verify" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.verify && verified" class="text-center">
                <v-btn
                  outlined
                  :color="maincolor"
                  :to="{ name: 'Login' }">
                  Log In
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Verifyuser',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      verify: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datauser: null,
    token: '',
    verified: false,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  watch: {
    '$route.query.token'(val) {
      if (val) {
        this.token = val;
        this.verifyUser();
      }
    },
  },
  mounted() {
    if (this.$route.query.token && this.$route.query.token !== '') {
      this.token = this.$route.query.token;
      this.verifyUser();
    } else {
      this.alertdata.show = true;
      this.alertdata.type = 'error';
      this.alertdata.text = 'Invalid URL!';
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    verifyUser() {
      // console.log(this.token);
      this.alertdata.show = false;
      this.verified = false;
      if (this.token) {
        this.loading.verify = true;
        this.axios
          .post(
            this.api + '/api/auth/verifyuser',
            qs.stringify(
              {
                token: this.token,
              },
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.verified = true;
                if (resdata.data.length === 0) {
                  this.alertdata.text = resdata.message;
                } else {
                  this.alertdata.text = 'Your account has been activated successfully.<br> You can now login';
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.verify = false;
          })
          .catch((error) => {
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.verify = false;
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Invalid URL!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
